import { render, staticRenderFns } from "./TestimonialHomeEight.vue?vue&type=template&id=9bcd4b52&"
import script from "./TestimonialHomeEight.vue?vue&type=script&lang=js&"
export * from "./TestimonialHomeEight.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialHomeEight.vue?vue&type=style&index=0&id=9bcd4b52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports